import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/components/MainHero.css";

import Modal from "../../components/Modal";

import bgBase from "../../img/hero/bg-base.webp";
import blueWave from "../../img/hero/blue-wave.svg";
import dotsBullets from "../../img/hero/dots-3.webp";
import arrowCircle from "../../img/hero/arrow-circle-2.png";
import casesArrow from "../../img/hero/ArrowUpRight.png";
import casePhone from "../../img/hero/case-phone.webp";
import caseClouds from "../../img/hero/case-clouds.webp";

export default function MainHero() {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const servicesBlock = (
    <>
      <div className="services__row">
        <h3>OUR SERVICES</h3>

        <button
          className="icon-btn"
          aria-label="More services"
          onClick={() => navigate("/services")}
        >
          <img src={arrowCircle} alt="" aria-hidden="true" />
        </button>
      </div>

      <div className="chips">
        <span className="chip">AI Chat Agents</span>
        <span className="chip">AI Analytics</span>
        <span className="chip">GenAI &amp; Media</span>
        <span className="chip">Marketing Automation</span>
      </div>
    </>
  );

  const casesBlock = (
    <>
      <h3 className="cases__title">EXPLORE OUR CASES</h3>

      <button
        className="cases__btn"
        aria-label="Explore cases"
        onClick={() => navigate("/cases")}
      >
        <img className="cases__arrow" src={casesArrow} alt="Open cases" />
      </button>

      <div className="cases__media-frame">
        <p className="cases__description">
          AI-Powered Virtual Try-On with
          <br />
          Realistic Garment Rendering
        </p>

        <img
          className="cases__clouds"
          src={caseClouds}
          alt=""
          aria-hidden="true"
        />

        <img
          className="cases__phone"
          src={casePhone}
          alt="AI-Powered Virtual Try-On"
        />
      </div>
    </>
  );

  return (
    <section className="hero">
      <div className="hero__card">
        <img className="card-bg" src={bgBase} alt="" aria-hidden="true" />

        <img className="hero-wave" src={blueWave} alt="" aria-hidden="true" />

        <h1 className="hero-headline">
          We build AI agents that make{" "}
          <strong>your product personal</strong> —<br />
          with lifetime context, deep memory, and real impact
          <br />
          on retention, LTV, and ARPU.
        </h1>

        <div className="hero-social-card">
          <img
            className="hero-social-card__users"
            src={dotsBullets}
            alt=""
            aria-hidden="true"
          />

          <p className="hero-social-card__quote">
            "IT FEELS LIKE THE APP<br />
            ACTUALLY KNOWS ME."
          </p>

          <button
            className="Primary v2 hero-cta hero-social-card__cta"
            onClick={() => setOpenModal(true)}
          >
            <span>Start Your Project</span>
            <img src={arrowCircle} alt="" aria-hidden="true" />
          </button>
        </div>

        <div className="glass glass--services hero-desktop-only">
          {servicesBlock}
        </div>

        <div className="glass glass--cases hero-desktop-only">
          {casesBlock}
        </div>
      </div>

      <div className="hero-mobile-only hero-mobile-blocks">
        <div className="glass glass--services hero-mobile-services">
          {servicesBlock}
        </div>

        <div className="glass glass--cases hero-mobile-cases">
          {casesBlock}
        </div>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      />
    </section>
  );
}
